import React, { useEffect, useState } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Pricing } from "../components/Pricing";
import { useI18n } from "../i18n";

const faqKeys = [
  { q: "pricing.faq.q1", a: "pricing.faq.a1" },
  { q: "pricing.faq.q2", a: "pricing.faq.a2" },
  { q: "pricing.faq.q3", a: "pricing.faq.a3" },
  { q: "pricing.faq.q4", a: "pricing.faq.a4" },
  { q: "pricing.faq.q5", a: "pricing.faq.a5" },
];

function FaqItem({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-[#2a2040] rounded-xl overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-4 text-left text-white hover:bg-[#14121e] transition-colors"
      >
        <span className="font-medium">{question}</span>
        <svg
          className={`w-5 h-5 text-[#a078d0] flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
      {open && (
        <div className="px-6 pb-5 text-[#b0a0c0] text-sm leading-relaxed border-t border-[#2a2040]">
          <p className="pt-4">{answer}</p>
        </div>
      )}
    </div>
  );
}

export function PricingPage() {
  const { t } = useI18n();

  useEffect(() => {
    document.title = "Onyx AI Pricing — Plans for Malaysian Businesses";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Compare Onyx AI chatbot plans from Free to Business. Start free, scale as you grow. Pricing in RM for Malaysian SMEs."
      );
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", "https://onyxai.chat/pricing");
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a12]">
      <Header />
      <main className="pt-32 pb-20">
        {/* Page hero */}
        <div className="text-center px-6 mb-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t("pricing.title")}
          </h1>
          <p className="text-[#8a7a9a] text-lg max-w-2xl mx-auto">
            {t("pricing.subtitle")}
          </p>
        </div>

        {/* Pricing cards — title suppressed since h1 above covers it */}
        <Pricing showTitle={false} />

        {/* FAQ */}
        <section className="py-16 px-6">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center">
              {t("pricing.faq.title")}
            </h2>
            <div className="space-y-3">
              {faqKeys.map((item) => (
                <FaqItem
                  key={item.q}
                  question={t(item.q)}
                  answer={t(item.a)}
                />
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-10 px-6 text-center">
          <p className="text-[#8a7a9a] mb-4">
            {t("cta.subtitle")}
          </p>
          <a
            href="/signup"
            className="inline-block px-8 py-3 bg-[#7b5ea7] hover:bg-[#6a4f96] text-white font-medium rounded-lg transition-colors"
          >
            {t("cta.button")}
          </a>
        </section>
      </main>
      <Footer />
    </div>
  );
}
